import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import { CameraContext } from "../../LiveCamera/LiveCamera";
import { Toast } from "../../../components";
import { useStoreContext } from "../../../hooks/useStoreContext";
import { actions } from "../../../store";
import streamingClient from "../../../services/streamingClient";
import styles from "./WeraHouse.module.css";
import { LoseConnectStatus, OffStatus, OnStatus, WeakConnectStatus } from "../../../components/Icons/Icons";
import RenderStatus from "../../../components/StatusRender";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);
const Camera = ({
  name,
  status,
  check,
  camID,
  prioritized,
  isChange,
  setCheck,
  setIsChange,
  message,
  index
}) => {
  const { setIsApply, handleFullScreen, oneThread } = useContext(CameraContext);
  const [checkCamera, setCheckCamera] = useState(false);
  // eslint-disable-next-line
  const [dataStore, dispatch] = useStoreContext();
  const companyCode = sessionStorage.getItem('company_code');
  const { t } = useTranslation()
  const handleCheck = async (camID, check) => {
    setCheckCamera(!checkCamera);
    if (checkCamera) {
      setCheck(false);
      setIsChange(false);
    }
    if (!checkCamera) {
      dispatch(
        actions.getListCameraPriority({
          camera_code: camID,
          status_priority: "1",
        })
      );
      setIsApply(true);
    } else {
      dispatch(
        actions.getListCameraPriority({
          camera_code: camID,
          status_priority: "0",
        })
      );
      setIsApply(true);
    }
  };
  useEffect(() => {
    if (isChange) {
      setCheckCamera(check);
    }
  }, [prioritized, check]);
  useEffect(() => {
    setCheckCamera(prioritized === "1" ? true : false);
  }, []);
  const getListPathStreaming = async (code) => {
    let json = JSON.stringify({
      data: [
        {
          camera_code: code,
        },
      ],
    });
    try {
      const res = await streamingClient.post(
        "/streamManagement/post-list-path-streaming/",
        {
          list_camera: {
            data: [
              {
                camera_code: code,
              },
            ],
          },
        }
      );
      const listStream = res?.stream.map((item) => {
        if (item.code) {
          return {
            url: `${process.env.REACT_APP_BASE_URL}livestream${item?.data[1].PATH}`,
            url2: `${process.env.REACT_APP_BASE_URL}livestream${item?.data[0].PATH}`,
            isOption: false,
            name: item?.name,
            status: item?.data[0].STATUS,
            code: item?.code,
          };
        }
        return null;
      });
      return listStream;
    } catch (error) {
      // throw new Error("We can't get path streaming");
    }
  };
  const handleChoseCamera = async (code) => {
    const active = await getListPathStreaming(code);

    if (status === 0) {
      handleFullScreen(name, active, "DBClick");
    } else {
      Toast.open(t("location.cameraIsOff"), "danger");
    }
  };
  const handleCancelChose = (code, e) => {
    handleCheck(code, e.target.checked);
  };

  return (
    <div
      className={cx("item-cam")}
      onDoubleClick={(e) => handleChoseCamera(camID)}
    >
      <div className={cx("camera")}>
        <span className={cx("hover")}>
          <RenderStatus companyCode={companyCode} status={status} />
          <p className={cx('tooltip', index === 0 ? 'bottom' : 'top')}>
            {message}
          </p>
        </span>
        <span className={cx("name")}>{name}</span>
      </div>
      {!oneThread && (
        <input
          checked={checkCamera}
          onChange={(e) => handleCancelChose(camID, e)}
          className={cx("check")}
          type="checkbox"
          value={checkCamera}
        />
      )}
    </div>
  );
};
Camera.propTypes = {
  name: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  check: PropTypes.bool,
  camID: PropTypes.string.isRequired,
  // prioritized: PropTypes.string.isRequired,
};
export default Camera;
